import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { RPM_STATUS } from '../mockData/rpm-status';

const RpmStatusApi = [rest.get(`${API_ROOT}rpm-status`, (req, res, ctx) => res(ctx.json(RPM_STATUS)))];
export default RpmStatusApi;
